export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10082.d376c276.jpg";